import { Component } from '@angular/core';

@Component({
    selector: 'not-found',
    templateUrl: './not-found.component.html'
})
export class PageNotFoundComponent { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/not-found.component.ts